import { render, staticRenderFns } from "./ItemSlot.vue?vue&type=template&id=311afea6&scoped=true"
import script from "./ItemSlot.vue?vue&type=script&lang=js"
export * from "./ItemSlot.vue?vue&type=script&lang=js"
import style0 from "./ItemSlot.vue?vue&type=style&index=0&id=311afea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311afea6",
  null
  
)

export default component.exports